export const FETCH_FLIRTS = 'FETCH_FLIRTS'
export const FETCH_FLIRTS_SUCCESS = 'FETCH_FLIRTS_SUCCESS'
export const FETCH_FLIRTS_ERROR = 'FETCH_FLIRTS_ERROR'

export const FLIRT_LIKE = 'FLIRT_LIKE'
export const FLIRT_DISLIKE = 'FLIRT_DISLIKE'
export const FLIRT_SKIP = 'FLIRT_SKIP'
